import StarSharpIcon from 'components/common/icons/StarSharpIcon'

const MealAverageRating = ({ stars }: { stars: number }) => {
  const formattedStars = stars.toFixed(1)

  return (
    <span className="inline-flex items-center gap-x-0.5">
      <span
        aria-hidden="true"
        className="h-[12.44px] w-[12.44px] text-orange-2"
      >
        <StarSharpIcon />
      </span>

      <span aria-hidden="true" className="text-k/14_120 font-medium">
        {formattedStars}
      </span>

      <span className="sr-only">
        Average rating: {formattedStars} out of 5 stars
      </span>
    </span>
  )
}

export default MealAverageRating
